import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';

import MyNavbar from '../CommonComponents/Navbar'
import MyFooter from '../CommonComponents/Footer'


export default class Reviews extends Component {
        render() {
                return (

                        <div id="main-review-page">
                                <MyNavbar backgroundColor="white"/>
                                <MyFooter/>
                        </div>
                )
        }
}
